// 11位电话号码隐藏
import Vue from 'vue';

Vue.filter('hiddenTel', function (value) {
  if (!value || value.length < 1) return '';
  return value.substring(0, 3) + '****' + value.substr(value.length - 4);
});
